import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_BANK_TRANSACTIONS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_BANK_TRANSACTION:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_BANK_TRANSACTION:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_BANK_TRANSACTION:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_BANK_TRANSACTION:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
